import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { IntlContext } from '../../common/contexts';
import { getMessageLocale } from '../../common/utils';

const LocaleProvider = ({ children, translation }) => {
  const initialLocale = getMessageLocale({
    locale: navigator.language,
    preserved: ['zh'],
  });
  const [intl, setIntl] = useState({ locale: initialLocale, translation });

  useEffect(() => {
    const root = document.querySelector('html');

    root.lang = intl.locale;
  }, [intl.locale]);

  return (
    <IntlProvider
      key={intl.locale}
      locale={intl.locale}
      messages={intl.translation}
    >
      <IntlContext.Provider value={{ intl, setIntl }}>
        {children}
      </IntlContext.Provider>
    </IntlProvider>
  );
};

LocaleProvider.propTypes = {
  children: PropTypes.element.isRequired,
  translation: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default LocaleProvider;
